import { Component } from '@angular/core';
import { Router } from '@angular/router';

import { NavController, LoadingController } from '@ionic/angular';
import { SharedModule } from 'src/shared/shared.module';

import { MobileService, RequestService, Client } from '../../shared/shared';
import { AppBase } from '../base-classes/app-base';
import { Urls } from '../pages';

@Component({
  templateUrl: 'client-view.page.html',
  selector:"client-view"
})

export class ClientViewPage extends AppBase{

     currentWorker: any = {};
     noMatchedClients: boolean = false;
     visitStarted: boolean = false;
     backgroundClass: string = "";

    constructor (
        private router: Router,
        private nav: NavController,
        private mobileService: MobileService,
        private requestService: RequestService,
        public loading: LoadingController,
        private shared: SharedModule
    ) 
    {
        super(loading)
        this.initLoader()
     }

    async ionViewDidEnter()
    { 
        this.backgroundClass = this.mobileService.backgroundClass;
        this.visitStarted = false;
        this.currentWorker = this.requestService.workerData;

        var parseDate = function(x){
            x= x.split(' '); //format yy.MM.dd hh:mm:ss 1=> date, 2=> time
            var date =  x[0].split('.');
            date = 
                {
                    year: parseInt(date[0]),
                    month: parseInt(date[1]) - 1,
                    date: parseInt(date[2]),
                };

            var time =  x[1].split(':');
            time = 
                {
                    hour: parseInt(time[0]),
                    minutes: parseInt(time[1]),
                    seconds: parseInt(time[2]),
                };

                return new Date(date.year, date.month, date.date, time.hour, time.minutes, time.seconds);
        };

        if (!this.currentWorker.assignedClients){              

            if (this.requestService.loginResponse.isEmpty)
                {
                    this.noMatchedClients = true;
                    return;
                }
            else
            {
                this.currentWorker.assignedClients = this.requestService.loginResponse.map(function(e){
                    e.arrivalDate = !e.arrivalDate ? '' : parseDate(e.arrivalDate);
                    e.departureDate = !e.departureDate ? '' : parseDate(e.departureDate);
                    return new Client(e.patientID, e.lastName, e.firstName, e.serviceTypeID, e.serviceOrderID, e.visitStatus, e.arrivalDate, e.departureDate, e.duration|| 0, e.businessId);
                });
            }
            for ( let client of this.currentWorker.assignedClients )
            {
                if(client.visitStatus == 5)
                {
                    this.visitStarted = true;
                    break;
                }
            }
        }
        else
        {   
            this.showLoader()
            this.refreshList().then(e =>
            {
                if (e["error"]){
                console.log(e["error"]);
                }
                else if (e.isEmpty)
                {
                    this.noMatchedClients = true;
                }
                
                else 
                {
                    this.currentWorker.assignedClients = e.map(function(e){
                    e.arrivalDate = !e.arrivalDate ? '' : parseDate(e.arrivalDate);
                    e.departureDate = !e.departureDate ? '' : parseDate(e.departureDate);

                    return new Client(e.patientID, e.lastName, e.firstName, e.serviceTypeID, e.serviceOrderID, e.visitStatus, e.arrivalDate, e.departureDate, e.duration|| 0, e.businessId);
                    }); 
                }
                    for ( let client of this.currentWorker.assignedClients )
                    {
                        if(client.visitStatus == 5)
                        {
                            this.visitStarted = true;
                            break;
                        }
                    }
                 this.hideLoader()
            });
        }

    }

    refreshList(){

         return new Promise<any>(resolve =>{
                    
            this.requestService.getAssignedClients("api/Patient/GetAssignedPatients", {
                Workerid: this.currentWorker.MemberId.toString(),
                Businessid: this.currentWorker.BusinessId.toString(),
                date: new Date()
            }).subscribe( data =>{
                resolve(data);
            },
            err => {
            
            resolve({
                "error": err.error
            });
            });
        });        
    }

    nextStatus(client){
        if (client.visitStatus !=5){
        this.mobileService.currentClient = client;
        this.mobileService.currentClient.arrivalTime = "no clock in time";
        this.mobileService.currentClient.departureTime = "no clock out time";
        //this.nav.push(ReportArrivalPage);
        this.router.navigate([Urls.ReportArrivalPage]);
        }
        else if (client.visitStatus == 5)
        {
        this.mobileService.currentClient = client;
        var realDate = this.mobileService.currentClient.arrivalDate;
        this.mobileService.currentClient.arrivalTime = this.mobileService.currentClient.arrivalDate.getTime() + (-1*realDate.getTimezoneOffset()*60*1000);
        this.mobileService.currentClient.departureTime = "no clock out time";
        //this.nav.push(ReportDeparturePage);
        this.router.navigate([Urls.ReportDeparturePage]);
        }
    }

    logOut(){
        //this.nav.setRoot(LoginPage);
        this.router.navigate([Urls.LoginPage]);
    }
}